/* Horizontal rail arrows. Delegated on document because the recommendations
   markup is injected by Envy after page load. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-mx-rail-prev], [data-mx-rail-next]');
    if (!btn) return;
    var scope = btn.closest('.mx-flavors');
    var rail = scope && scope.querySelector('[data-mx-rail]');
    if (!rail) return;
    var card = rail.querySelector('.mx-card');
    var step = card ? card.offsetWidth + 16 : 240;
    rail.scrollBy({
      left: btn.hasAttribute('data-mx-rail-prev') ? -step : step,
      behavior: 'smooth'
    });
  });
})();